import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function HasCocCheckbox() {
  return <Field type="checkbox" name="hasCoc" label={i18n.t('entity.vehicle.labels.hasCoc')} />;
}
